import type { ReactNode } from 'react';
import { useManagerRealtime } from './useManagerRealtime';

/**
 * Phase 8 (2026-05-07) — single mount point for the manager Realtime
 * subscription. Wraps each manager-protected route element so the
 * subscription is alive whenever the manager is on a manager page.
 *
 * Subscription tears down on unmount — when the manager navigates
 * away from the manager surface (sign-out, back to /, etc.), the
 * Supabase channel is removed.
 */
export function ManagerRealtimeProvider({ children }: { children: ReactNode }) {
  useManagerRealtime();
  return <>{children}</>;
}
